import React from "react";
import { useTranslation } from "react-i18next";
import { getSiteConfig } from "@/config/siteConfigs";
import ConsentAwareEmbed from "@/components/ConsentAwareEmbed/ConsentAwareEmbed";
import styles from "./MapBlock.module.scss";

const MapBlock: React.FC = () => {
  const { t } = useTranslation("common");
  const siteConfig = getSiteConfig();
  const contactInfo = siteConfig?.contact || {
    phone: "+49 30 520 151 91",
    email: "kunden@hixa.eu",
    address: "Neukirchstraße 74, 13089 Berlin",
  };

  return (
    <div className="container sideP88 mb60">
      <div className={styles.mapBlock}>
        <div className={styles.contactInfo}>
          <div className={styles.infoBlock}>
            <p className={styles.label}>{t("contact.phone")}</p>
            <a className={styles.phone} href={`tel:${contactInfo.phone}`}>
              {contactInfo.phone}
            </a>
          </div>
          <hr />
          <div className={styles.infoBlock}>
            <p className={styles.label}>{t("contact.email")}</p>
            <a href={`mailto:${contactInfo.email}`}>
              <span className={styles.value}>{contactInfo.email}</span>
            </a>
          </div>
          <hr />
          <div className={styles.infoBlock}>
            <p className={styles.label}>{t("contact.office")}</p>
            <span className={styles.value}>{contactInfo.address}</span>
          </div>
        </div>
        {contactInfo.address && (
          <div className={styles.mapContainer}>
            <ConsentAwareEmbed type="google-maps">
              <iframe
                src={`https://maps.google.com/maps?q=${encodeURIComponent(
                  contactInfo.address
                )}&t=ROADMAP&z=12&output=embed&iwloc=near`}
                width="100%"
                height="520px"
                style={{ border: "0" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={contactInfo.address}
              />
            </ConsentAwareEmbed>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapBlock;
